import { ParsedSubscriptionStatus, SubscriptionStatusData } from '../models/membership-tier.model';

/**
 * Least-privilege default — used before the first `fetchStatus()` resolves,
 * and whenever the fetch fails. Failing closed to Core matches the Hub's own
 * resolver default (`MembershipTierService.resolveTierFromAccount`: no row →
 * core) rather than assuming Pro when we can't confirm it.
 */
export const DEFAULT_SUBSCRIPTION_STATUS: ParsedSubscriptionStatus = {
  tier: 'core',
  isPro: false,
  status: null,
  renewalDate: null,
  cancelAtPeriodEnd: null,
  priceCents: null,
};

/**
 * Pure transform from the Hub's wire shape to the app-facing shape.
 * Extracted so it's testable without Angular's TestBed (this repo's Jest
 * config runs under `testEnvironment: 'node'` with no `jest-preset-angular`
 * — see agent-os/standards/testing/qa-test-plan-prompt.md's "Known
 * test-harness limitations").
 */
export function parseSubscriptionStatus(data: SubscriptionStatusData): ParsedSubscriptionStatus {
  return {
    tier: data.tier,
    isPro: data.tier === 'pro',
    status: data.status,
    renewalDate: data.currentPeriodEnd ? new Date(data.currentPeriodEnd) : null,
    cancelAtPeriodEnd: data.cancelAtPeriodEnd,
    priceCents: data.priceCents,
  };
}
